<template>
  <!-- 账号管理设置页面 -->
  <!-- 设置页面的内容区域 -->
  <!-- // 代号 20241212-1  整页-->
  <div class="config_main_manage_page_wraper">
    <div class="config_main_manage_page_content">
      <!-- 设置页面  内容区域样式   以上部分都是公共样式 -->

      <config-title-hang>
        <span v-if="dotLoading.state" slot="config_title_hang_ele2">协助设备入网中<span class="dot-text">{{ dotLoading.dots
            }}</span></span>
        <span v-else slot="config_title_hang_ele2">已停止协助入网</span>

        <span slot="config_title_hang_ele6" @click="startNetIn()">重新开始</span>
        <span slot="config_title_hang_ele5" @click="stopNetIn()">停止入网</span>
      </config-title-hang>
      <div class="status-text">
        <div>
          当前状态:{{ codeDescription }}
        </div>
      </div>
      <div class="xiaotishi_style" style="margin-top: 0px;" v-if="code == 220">
        小提示:此时,需确保待入网设备已在当前thread网络覆盖范围内,并且已处于待入网状态,耐心等候即可~。
        <br>
        待入网状态:一般为长按入网按键3S以上,松手,设备灯快速呼吸闪烁,既为待入网状态.(部分设备操作会有差异,以实际为准~)
      </div>

      <div class="xiaotishi_style" style="margin-top: 0px;" v-if="code == 221">
        小提示:边界网关可能出错,尝试重启或联系技术人员~
      </div>
      <div class="xiaotishi_style" style="margin-top: 0px;" v-if="code == 222">
        小提示:可能是人为操作了边界网关,停止了协助入网哦~
      </div>
      <div class="xiaotishi_style" style="margin-top: 0px;" v-if="code == 223">
        小提示:成功更近一步,耐心等候即可~
      </div>
      <div class="xiaotishi_style" style="margin-top: 0px;" v-if="code == 224">
        小提示:设备安全入网后,可能会有最长30秒的角色分配过程,30秒后,才能在 设备上线页面->新发现设备 列表中出现哦!
        <br>
        此时,可选择重现开始,继续下一台.(若有大量设备需要入网,此方案可能速度较慢,可以尝试其他方案哦~)
      </div>
      <div class="xiaotishi_style" style="margin-top: 0px;" v-if="code == 225">
        小提示:协助入网,因超时而结束了,可尝试重新开始~
      </div>
      <div class="xiaotishi_style" style="margin-top: 0px;" v-if="code == 0">
        入网流程:<br>
        1. 点击 重新开始 使当前页面显示 协助设备入网中...。
        <br>
        2. 使设备处于待入网状态(一般为长按入网按键3S以上,松手,设备灯快速呼吸闪烁,既为待入网状态)。
        <br>
        3. 等待设备协商入网,直到入网成功。
        <br>
        4. 再次点击 重新开始 即可再次协助下一个设备入网。
      </div>

      <div class="xiaotishi_style" style="margin-top: 0px;" v-if="code == 1">
        小提示:此时,耐心等候即可~。
      </div>

      <div v-if="endTimeDescription != ''" class="xiaotishi_style" style="font-weight: bold;">
        {{ endTimeDescription }}
      </div>



      <!-- <div class="xiaotishi_style">
          小提示:<br>
          设备入网是指,协助待入网的设备获取当前网络的密钥,以允许设备安全的加入当前网络。
          <br>
          进入当前页面系统会自动进入协助入网状态,退出当前页面会自动停止协助入网。
          <br>
          每次开始协助入网后,均会有超时时间(120S 左右),超时后会自动停止协助入网,并停留在当前页面。
          <br>
          设备入网成功后,会有大约 30S 的设备角色和密钥协商过程,30 秒后,才能在 新发现设备 列表中出现.
        </div> -->


    </div>
  </div>
</template>

<script>
import configHang from "components/common/config/config-hang";
import configTitleHang from "components/common/config/config-title-hang";
export default {
  data() {
    return {
      oneHostDeviceListData: {
        ////服务器请求到的主机下面的设备列表
        offLineList: [],
        onLineList: [],
        threadNewProductList: []
      },
      oneHostData: {
        ////一个主机的信息
      },
      query: {},
      dotLoading: {
        dotInterval: null,
        dots: ".",      // 初始为一个点
        dotCount: 1,    // 当前显示的点的数量
        dotCountMax: 5, // 最多显示的点的数量
        state: false,  // 控制点显示的状态，默认不显示 / 是否正在入网
      },
      code: 0,// 入网状态
      codeDescription: "",// 入网状态描述
      endTimeDescription: "",//结束时间描述 
    };
  },
  components: {
    configHang,
    configTitleHang
  },
  methods: {
    startLoadingDots() {
      this.stopLoadingDots(); // 先尝试停止,避免多次启动
      if (this.dotLoading.state) return; // 如果不处于加载状态，直接返回
      this.dotLoading.state = true;
      this.endTimeDescription = "";
      // 每500毫秒更新一次点的数量
      this.dotLoading.dotInterval = setInterval(() => {
        if (this.dotLoading.dotCount < this.dotLoading.dotCountMax) {
          this.dotLoading.dotCount++;
        } else {
          this.dotLoading.dotCount = 1; // 如果点达到三个，则重置为一个点
        }
        this.dotLoading.dots = '.'.repeat(this.dotLoading.dotCount); // 更新显示的点
      }, 500); // 每500ms更新一次
    },
    stopLoadingDots() {
      this.endTimeDescription = "";
      this.dotLoading.state = false; // 设置为不加载状态
      this.dotLoading.dots = "";      // 清空点的显示
      if (this.dotLoading.dotInterval != null) {
        clearInterval(this.dotLoading.dotInterval); // 停止定时器
        this.dotLoading.dotInterval = null;
      }


    },
    startNetIn() {
      if (this.code == 223) {
        this.$showTips1Toast(3, "当前状态,无法重新开始,稍后重试!", true);
        // this.$showToast("当前状态,无法重新开始,稍后重试!");
        return;
      }
      this.code = 1;
      this.codeDescription = "准备开始协助设备入网!"
      // 设置某个网关的 thread 设备的 commissioner功能- 打开或关闭-协助一个joiner设备入网
      this.$asyncMessageKeyRequest({
        url: "/gateway/setThreadDeviceCommissioner",
        data: {
          token: this.$store.state.token,
          gatewayId: this.oneHostData.gatewayId,

          state: true, // true 开启协助入网，false 关闭协助入网
        },
        customLoadingStartFn: this.startLoadingDots,
        customLoadingStopFn: this.stopLoadingDots,
        getRequestLimitsFn: this.getRequestLimitsCallback
      }, this.redisMessageIdCallback)
    },
    redisMessageIdCallback(res, stopUpdateTimerFn) {
      const { data } = res;
      console.log("返回数据:", data);
      // 如果更新完成，停止定时器
      // commissioner 部分
      //   U_CB_STATE_C_START(220, "已开始,正在搜寻入网设备!"), // 回调
      // U_CB_STATE_C_ERROR_STOP(221, "已停止,因添加joiner失败而停止!"), // 回调
      // U_CB_STATE_C_STOP(222, "已停止,因设备按键操作而停止!"), // 回调
      // U_CB_STATE_C_FOUND_J_START(223, "已发现入网设备,并开始入网流程!"), // 回调
      // U_CB_STATE_C_FOUND_J_END_STOP(224, "已完成一台设备安全入网,可重新开始下一台!"), // 回调
      // U_CB_STATE_C_J_REMOVE_STOP(225, "已停止,协助入网超时!"), // 回调
      // U_CB_STATE_C_NET_STOP(226, "已停止协助入网!"), // 回调 此状态不应上报
      if (data.mapData != null) {
        this.code = data.mapData.code;
        this.codeDescription = data.mapData.codeDescription;
        if (data.mapData.code == 221 || data.mapData.code == 222 || data.mapData.code == 224 || data.mapData.code == 225 || data.mapData.code == 226) {
          console.log("当前完成时间:", new Date());
          stopUpdateTimerFn(); // 停止循环定时器
        }
      }
    },
    getRequestLimitsCallback(timingCount, maxTimingCount, timingCycleS, timingCurrentSec) {
      // 剩余轮训定时器回调
      let endTime = maxTimingCount * timingCycleS - timingCurrentSec;
      endTime - 6 > 0 ? endTime = endTime - 6 : endTime = 0;

      this.endTimeDescription = "协助入网超时时间: 预计剩余( " + endTime + " )秒!";

      // 错误检查 -- 详见代码 readme.md 的已知 bug:10
      if (timingCurrentSec >= 10) {
        // 10秒后,code 还是 1,说明主机没有返回成功开始的状态码
        if (this.code == 1) {
          this.stopNetIn();
          this.$showTipsToast(3, "开始失败,请检查主机与leader的通讯,或等待通讯网格自修复后,再次尝试~");
        }
      }

    },

    stopNetIn() {
      ///刷新设备按钮被点击了
      // console.log(this.$route.query.typeId);

      ///获取网关下的产品列表 接口，获取数据
      this.$request({
        method: "post",
        url: "/gateway/setThreadDeviceCommissioner",
        data: {
          token: this.$store.state.token,
          gatewayId: this.oneHostData.gatewayId,

          state: false, // true 开启协助入网，false 关闭协助入网
        }
      })
        .then(res => {
          if (res.data.code != 0) {
            this.$showTipsToast(3, res.data.message);
            ////说明信息填写错误,控制失败了，
            return;
          } else {
            ////、控制成功了
            console.log(res.data.data);
            // 排序 20200624
            // this.oneHostDeviceListData = res.data.data; ////拿到服务器返回的数据结果
            // this.$showTipsToast(1, "获取成功", true); ////提示框
            this.code = 0;
            this.codeDescription = "已停止协助设备入网!"
            // 停止异步回调接口
            this.$asyncMessageKeyRequest({
              customLoadingStartFn: this.startLoadingDots,
              customLoadingStopFn: this.stopLoadingDots,
              isHandStop: true
            }, null);

          }
        })
        .catch(error => {
          console.log(error);
        });
    },

  },
  computed: {

  },
  mounted() {
    console.log("mounted阶段");
    // 当组件挂载时，开始定时器
    this.startNetIn();
    // this.$showLoading(4, "加载中，请耐心等待");
  },
  created() {
    console.log("created阶段");
    this.query = this.$route.query;
    this.oneHostData = this.$store.state.configinfo.oneHostData; ///拿到仓库当前主机的信息
    this.oneHostDeviceListData = this.$store.state.configinfo.oneHostDeviceListData; ///拿到仓库当前主机下的设备列表
    console.log(this.query);
    console.log(this.oneHostData);
    console.log(this.oneHostDeviceListData);
    //  this.$forceUpdate()  ////强制更新视图
  },
  beforeDestroy() {
    console.log("beforeDestroy阶段");
    // 只有正在入网 才调用停止接口
    if (this.dotLoading.state) {
      // 停止异步回调接口(先调用一次,避免stopNetIn接口异常,导致无法停止异步轮训查询接口定时器)
      this.$asyncMessageKeyRequest({
        customLoadingStartFn: this.startLoadingDots,
        customLoadingStopFn: this.stopLoadingDots,
        isHandStop: true
      }, null);
      this.stopNetIn();
    }

  }
};
</script>

<style>
.device_go_online_btn_corol {
  color: var(--primary-color);
}

/* 设置点的字体大小和居中显示 */
.dot-text {
  font-size: 20px;
  /* 设置点的大小 */
  font-weight: bold;
  /* 设置字母间距 */
  letter-spacing: 5px;

}

.status-text {
  /* 深色文字 */
  color: #282828;

  /* 合适的字体大小 */
  font-size: 16px;

  /* 加粗文字 */
  font-weight: bold;


  /* 淡蓝色背景 */
  background-color: rgba(68, 180, 253, 0.3);



  /* 上下 10px，左右 15px 内边距 */
  padding: 15px 15px;

  /* 圆角边框 */
  border-radius: 5px;

  /* 轻微阴影效果 */
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

  /* 使用 flex 布局，纵向排列 */
  display: inline-block;
  /* 让背景仅根据内容宽度自适应 */

  /* 左对齐 */
  justify-content: flex-start;

  /* 保证子元素居中 */
  align-items: flex-start;

  /* 上下间距，左右不增加外边距 */
  margin: 20px 0;

  /* 包括内边距和边框在总宽度/高度内 */
  box-sizing: border-box;
}

/* 每个 div 元素的底部间距 */
/* .status-text>div {

  margin-bottom: 5px;
} */
</style>